module.exports = __webpack_public_path__ + "static/media/modelo-a.cd0d3ac1.png";